// Generated from SVG to Code Figma Plugin

export const BaseLineRecreate = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21 10.5V8.25C21 6.17893 19.3211 4.5 17.25 4.5H6.75C4.67893 4.5 3 6.17893 3 8.25V15.75C3 17.8211 4.67893 19.5 6.75 19.5H12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M15.5014 18.418C15.1803 18.7394 15 19.1752 15 19.6295V21H16.3803C16.8351 21 17.2713 20.8193 17.5928 20.4976L21.9571 16.1314C22.5332 15.5551 22.5332 14.621 21.9571 14.0447C21.3805 13.4679 20.4454 13.468 19.8691 14.0451L15.5014 18.418Z"
      fill="currentColor"
    />
  </svg>
);
